export interface GetListResponseJSON {
  data: SftpKeysJSON;
}

export interface GenerateResponseJSON {
  data: SftpPrivateKeyJSON;
}

export interface RemoveResponseJSON {
  data: { key_name: string };
}

// Sftp public Key JSON
interface SftpKeyJSON {
  name: string;
  created_by: string;
}

// Sftp public Keys JSON
interface SftpKeysJSON {
  keys: SftpKeyJSON[];
}

// Sftp public Key
export class SftpKey {
  public constructor(public name: string, public createdBy: string) {}

  // Constructs an object from a JSON-encoded sftp key
  public static fromJSON(sftpKeyJSON: SftpKeyJSON): SftpKey {
    return new SftpKey(sftpKeyJSON.name, sftpKeyJSON.created_by);
  }
}

// Sftp public keys.
export class SftpKeys {
  public constructor(public keys: SftpKey[]) {}

  // Constructs an object from JSON-encoded keys.
  public static fromJSON(sftpKeysJSON: SftpKeysJSON): SftpKeys {
    const keys: SftpKey[] = [];
    for (const keyJson of sftpKeysJSON.keys) {
      keys.push(SftpKey.fromJSON(keyJson));
    }
    return new SftpKeys(keys);
  }

  public getKeyNames(): string[] {
    return this.keys.map((key) => key.name);
  }
}

// Sftp private key JSON
interface SftpPrivateKeyJSON {
  name: string;
  content: string;
  created_by: string;
}

// Sftp private Key
export class SftpPrivateKey {
  public constructor(public name: string, public content: string, public createdBy: string) {}

  // Constructs an object from a JSON-encoded sftp key
  public static fromJSON(keyJSON: SftpPrivateKeyJSON): SftpPrivateKey {
    return new SftpPrivateKey(keyJSON.name, keyJSON.content, keyJSON.created_by);
  }
}
